/**
 * @generated SignedSource<<52e64610191d172700fe8ecfce1093bf>>
 * @relayHash 53666bf1c9b6e755c7bb77693279ee3d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 29570588328f466bf21bce3b0889d8d158a1b0cb5f44cbd62b8ef8385cb1d6e7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BacklogFilterRefinementQuery } from './BacklogFilterRefinementQuery.graphql';

import isProjectsInJiraM1Enabled_provider from '@jira/platform__filter-refinement/src/ui/relay-providers/projects-in-jira-eap-drop1.relayprovider';

const node: PreloadableConcreteRequest<BacklogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "29570588328f466bf21bce3b0889d8d158a1b0cb5f44cbd62b8ef8385cb1d6e7",
    "metadata": {},
    "name": "BacklogFilterRefinementQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__filterrefinementsrcuirelayprovidersprojectsinjiraeapdrop1relayprovider": isProjectsInJiraM1Enabled_provider
    }
  }
};

export default node;
